import buymedicineservices from "../../services/buymedicineservices";

export const postDataLogin = async (payload) => {
    const res = await buymedicineservices.postDataLogin(JSON.stringify(payload));
    return res;
};

